module.exports = __webpack_public_path__ + "static/img/normal.cfe49f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/normal.png
// module id = 5NA8
// module chunks = 1